import { formatInternational } from 'lib-shared-phone-numbers';
import type { SearchUser } from 'lib-shared-types-api';

import type { PhoneNumberUserSelectItem } from '../phoneNumberUserSelect.types';

/** Converts a phone number to a phone number select item. */
export const searchUserToPhoneNumberSelectItem = (
  user: SearchUser,
  index: number,
): PhoneNumberUserSelectItem & { key: string } => {
  const number = user.phone_number ?? '';
  return {
    id: number,
    name: formatInternational(number) ?? '',
    description: user.display_name ?? '',
    key: `${number}_${index}`,
  };
};
